import { defineAction } from '~/prix'
import { z } from 'zod'
import creditProgramFetchAction from './creditProgramFetch.action.json' with { type: 'json' }
import { creditProgramObject } from '../creditProgramObject'

const creditProgramFetchDefinition = defineAction({
  ...creditProgramFetchAction,

  input: z.object({
    id: creditProgramObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: creditProgramObject,
})

export default creditProgramFetchDefinition

